'use strict';

angular.module('userRequestEditControllers')

.controller('ValidationMessagesController', ['$scope', 'validationMessages', function ($scope, validationMessages) {

    $scope.validationMessages = validationMessages;

}]);